import {delayHit, hitAlgolytics} from "@pg-mono/algolytics"; // we use this for unification process

import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const neighborhoodOffersClickHit = (viewType: ViewType, offerId: number | null) => {
    const payload = {
        ...getTrackedSiteData(),
        view_type: viewType,
        offer_id: offerId
    };
    neighborhoodOffersClickHitAlgolytics(payload);
};

export const neighborhoodOffersClickHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("neighborhood_offers_click", payload), 500);
import {delayHit, hitAlgolytics} from "@pg-mono/algolytics"; // we use this for unification process

import {ViewType} from "../../view_type/ViewType";
import {getTrackedSiteData} from "./tracked_utils/tracked_site";

export const neighborhoodOffersClickHit = (viewType: ViewType, offerId: number | null) => {
    const payload = {
        ...getTrackedSiteData(),
        view_type: viewType,
        offer_id: offerId
    };
    neighborhoodOffersClickHitAlgolytics(payload);
};

export const neighborhoodOffersClickHitAlgolytics = delayHit((payload: Object) => hitAlgolytics("neighborhood_offers_click", payload), 500);
